import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './components/Home';
import Program from './components/Program';
import Announcement from './components/Announcement';
import BuildingCleaning from './components/BuildingCleaning'
import SundaySchool from './components/SundaySchool';
import Emergency from './components/Emergency';
import Elders from './components/Elders';
import Primary from './components/Primary';
import ReliefSociety from './components/ReliefSociety';
import YoungMen from './components/YoungMen';
import YoungWomen from './components/YoungWomen';
import Communication from './components/Communication';
import ErrorBoundary from './components/shared/ErrorBoundary';
import Error404 from './components/shared/Error404';

export default () => (
  <Layout>
    <ErrorBoundary>
      <Routes>
        <Route path='/'>
          <Route index element={<Home />} />
          <Route path='program'>
            <Route index element={<Program />} />
            <Route path=':year/:month/:day' element={<Program />} />
          </Route>
          <Route path='announcements' element={<Announcement />} />
          <Route path='communication' element={<Communication />} />
          <Route path='building-cleaning' element={<BuildingCleaning />} />
          <Route path='sundayschool' element={<SundaySchool />} />
          <Route path='emergency-prep' element={<Emergency />} />
          <Route path='elders' element={<Elders />} />
          <Route path='primary' element={<Primary />} />
          <Route path='rs' element={<ReliefSociety />} />
          <Route path='ym' element={<YoungMen />} />
          <Route path='yw' element={<YoungWomen />} />
          <Route path='*' element={<Error404 />}></Route>
        </Route>
      </Routes>
    </ErrorBoundary>
  </Layout>
);